import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmDelete, Typography } from '@metarouter-private/mr-mui';

import useDeleteTag from './useDeleteTag';

export default function DeleteTagConfirm({ open, onClose, tag }) {
  const { onConfirm } = useDeleteTag({ tag, onClose });
  const message = <Typography>Are you sure you want to delete the tag &quot;{tag.label}&quot;?</Typography>;

  return <ConfirmDelete open={open} onClose={onClose} onConfirm={onConfirm} title="Delete Tag" message={message} />;
}

DeleteTagConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tag: PropTypes.object.isRequired,
};
